import { createAction } from '@mendeley-internal/lib-js-redux-actions';
import api from '../services/api/request';

const getConfig = scopusDocumentIds => ({
  params: {
    scopusDocumentIds
  }
});

export const getStats = createAction(
  'GET_STATS',
  ({ scopusDocumentId }) => (
    api.get('stats', getConfig(scopusDocumentId))
      .batch(requests => getConfig(requests.map(({ params: { scopusDocumentIds } }) => scopusDocumentIds).join(',')))
      .setCritical(false)
  ),
  ({ documentId }) => ({ documentId })
);



// WEBPACK FOOTER //
// ./src/universal/ui/actions/stats.js